import type { MonospaceNamespace } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';

export const Namespace = RStoreSchema.withItemType<MonospaceNamespace>().defineCollection({
	name: 'MonospaceNamespace',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: ['id', 'dbName', 'sourceId', 'isSystem'],
		useWorkspaceSlug: true,
	},
});
